module.exports = __webpack_public_path__ + "media/assets/icons/caretUp-0cf5e066116cb00ae405582e0e8e1311.svg";